import frontinstance from "./util/front_util";

const customizeServer = {
    // 新增首页
    async UpdateFrontConfig(formData){
        try{
            const response = await frontinstance.post("/update", formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return response.data;
        }catch(error){
            console.log(error)
        }
    },

}

export default customizeServer